
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ConsultationHero from './components/ConsultationHero';
import ConsultationForm from './components/ConsultationForm';
import TechnicalTeam from './components/TechnicalTeam';

const Consultation = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ConsultationHero />
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12">
            <ConsultationForm />
            <TechnicalTeam />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Consultation;
